import script from "./UserInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfoView.vue?vue&type=style&index=0&id=47d7a1a0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d7a1a0"]])

export default __exports__